import { ClienteDaImportacaoCSV } from "@/models";
import { Inject } from "inversify-props";
import { ClienteServiceAdapter } from "./adapter";
export class ImportaClientesUseCase {
	@Inject('ClienteServiceAdapter')
	private clienteService!: ClienteServiceAdapter

	async execute(items: ClienteDaImportacaoCSV[]): Promise<any> {
		this.clienteService.importaItens(items)
	}
	
}